/**
 * ===========================
 *        AEP SWITCH
 * ===========================
 * Toggle to enable or disable AEP mode (November 1 - December 15) 11/1 - 12/15 11:59PM.
 * When set to true, AEP mode is active and users can select quotes for both CURRENT_YEAR and NEXT_YEAR effective dates.
 * When set to false, AEP mode is inactive and only CURRENT_YEAR quote is selected by default.
 */
export const SWITCH_ON_AEP = import.meta.env.VITE_SWITCH_ON_AEP === 'true' ? true : false;

/**
 * AEP runs from November 1 to December 15 (11/1 - 12/15 11:59PM) for individual medical under 65 rate quotes.
 * Update these variables NEXT_YEAR and CURRENT_YEAR in this file if AEP dates change in the future.
 */

const now = new Date();
const estNow = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));

const isAepJanuary = estNow.getMonth() === 0 && estNow.getDate() <= 15;

function isItTodayGreaterThanOrDec1AndTillJan15(date: Date): boolean {
    // Returns true if the date is December 1st, December 31st, or between January 1 and January 15
    return (
        (date.getMonth() === 11 && date.getDate() >= 1 && date.getDate() <= 31) ||
        (date.getMonth() === 0 && date.getDate() >= 1 && date.getDate() <= 15)
    );
}
// function isWithinDec16ToDec31(date: Date): boolean {
//     // Returns true if date is between December 16 and December 31 (inclusive)
//     return date.getMonth() === 11 && date.getDate() >= 16 && date.getDate() <= 31;
// }

let NEXT_YEAR: string;
let CURRENT_YEAR: string;

if (!SWITCH_ON_AEP) {
    NEXT_YEAR = (estNow.getFullYear() + 1).toString();
    CURRENT_YEAR = estNow.getFullYear().toString();
} else {
    NEXT_YEAR = (isAepJanuary ? estNow.getFullYear() : estNow.getFullYear() + 1).toString();
    CURRENT_YEAR = (isAepJanuary ? estNow.getFullYear() - 1 : estNow.getFullYear()).toString();
}

export { NEXT_YEAR, CURRENT_YEAR };

export const IS_AEP_SELECTION_WINDOW = SWITCH_ON_AEP;
//&& isWithinNov1ToDec15(estNow);
export const IS_POST_AEP_LOCK_NEXT_YEAR_WINDOW = isItTodayGreaterThanOrDec1AndTillJan15(estNow);
export const IS_EFFECTIVE_PLAN_YEAR_EDITABLE = IS_AEP_SELECTION_WINDOW;
//export const DEFAULT_EFFECTIVE_PLAN_YEAR = IS_POST_AEP_LOCK_NEXT_YEAR_WINDOW ? NEXT_YEAR : CURRENT_YEAR;

// Backward-compatible export name used by existing consumers.
export const IS_IT_TODAY_GREATER_THAN_OR_DEC1_AND_TILL_JAN15_RESULT = isItTodayGreaterThanOrDec1AndTillJan15(estNow);

export const NEXT_YEAR_EFFECTIVE_DATE = `01/01/${NEXT_YEAR}`;
export const CURRENT_YEAR_EFFECTIVE_DATE = `01/01/${CURRENT_YEAR}`;
export const DISCONTINUOUS_PLAN_DATE = '11/01/2025'; // Date after which discontinued banner is removed from plan cards
